import Link from 'next/link';

type Props = {
  slug: string;
  title?: string;
  children?: React.ReactNode;
};

const LegacyStaticPageLink = ({ slug, title, children }: Props) => (
  <Link href="/page/[slug]" as={`/page/${slug}`} passHref={!!children}>
    {children ? children : <a aria-label="Page">{title}</a>}
  </Link>
);

export default LegacyStaticPageLink;
